/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ConsultationSection.vue?vue&type=template&id=d97c3b98"
import script from "./ConsultationSection.vue?vue&type=script&lang=js"
export * from "./ConsultationSection.vue?vue&type=script&lang=js"
import style0 from "./ConsultationSection.vue?vue&type=style&index=0&id=d97c3b98&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports